import React from "react"
import { Spin } from "antd"

import css from "./index.module.css"

export const InitializingPage: React.FC = () => {
  return (
    <div className={css.initializing}>
      <Spin size="large" style={{ margin: 20 }} />
    </div>
  )
}
